<template>
  <div class="flight-card-skeleton">
    <!-- Header: airline name | mer info -->
    <div class="row row--header">
      <div class="sk sk--airline" />
      <div class="sk sk--mer-info" />
    </div>

    <!-- Single flight row: icon | time | airport | ──route── | airport | time | badge -->
    <div class="row row--flight">
      <div class="sk sk--icon sk--circle" />

      <div class="sk sk--time" />
      <div class="sk sk--iata" />

      <div class="route-line">
        <!-- <div class="sk sk--duration" /> -->
        <div class="line-track">
          <div class="sk sk--seg" />
          <div class="sk sk--dot sk--circle" />
          <div class="sk sk--seg" />
        </div>
        <!-- <div class="sk sk--stops" /> -->
      </div>

      <div class="sk sk--iata" />
      <div class="sk sk--time" />

      <div class="sk sk--badge" />
    </div>

    <!-- Footer: available-at label | logo pill | CTA pill -->
    <div class="row row--footer">
      <div class="sk sk--available" />
      <div class="footer-actions">
        <!-- <div class="sk sk--logo-btn" /> -->
        <div class="sk sk--cta-btn" />
      </div>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped lang="scss">
@keyframes shimmer {
  0%   { background-position: -70rem 0; }
  100% { background-position:  70rem 0; }
}

.sk {
  --sh-base: #e8e8e8;
  --sh-hi:   #f4f4f4;
  background: linear-gradient(
    90deg,
    var(--sh-base) 25%,
    var(--sh-hi)   50%,
    var(--sh-base) 75%
  );
  background-size: 70rem 100%;
  animation: shimmer 1.6s infinite linear;
  border-radius: $borderRadius-xs;
  flex-shrink: 0;
}

/* Card shell */
.flight-card-skeleton {
  background: $white;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0;

  @include breakpoint_down(md) {
    padding: 0;

  }
}

/* Shared row base */
.row {
  display: flex;
  align-items: center;
  width: 100%;
}

/* ── Header row ── */
.row--header {
  justify-content: space-between;
  margin-bottom: 1.4rem;
}

.sk--airline   { height: 1rem; width: 5rem; }
.sk--mer-info  { height: 1rem; width: 6rem; }

/* ── Flight row ── */
.row--flight {
  gap: 1rem;
  margin-bottom: 1.4rem;

  @include breakpoint_down(md) {
    gap: .5rem;
  }
}

.sk--circle { border-radius: 50%; }
.sk--icon   { width: 28px; height: 28px; }
.sk--time   { height: 26px; width: 58px; }
.sk--iata   { height: 1.4rem; width: 28px; }

/* Route line stretches to fill */
.route-line {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: .5rem;
  min-width: 0;
}

.sk--duration { height: 11px; width: 46px; }
.sk--stops    { height: 11px; width: 58px; }

.line-track {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 4px;
}

.sk--seg { flex: 1; height: 2px; border-radius: 1px; }
.sk--dot { width: 7px; height: 7px; flex-shrink: 0; }

/* Ekonomi badge */
.sk--badge {
  height: 30px;
  width: 80px;
  border-radius: 6px;
}

/* ── Footer row ── */
.row--footer {
  border-top: 1px solid #e8e8e8;
  padding-top: 13px;
  justify-content: space-between;
  align-items: center;
}

.sk--available { height: 12px; width: 120px; }

.footer-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.sk--logo-btn { height: 36px; width: 120px; border-radius: 20px; }
.sk--cta-btn  { height: 36px; width: 160px; border-radius: 20px; }
</style>
